export const ACTIONS = {
  SET_LETTER: "SET_LETTER",
};
